export default {
  // 模式
  "common.mode.auto": "Mod automatik menggunakan tenaga dijana sendiri",
  "common.mode.economy": "Mod ekonomi",
  "common.mode.exigency": "Mod kecemasan",

  // 设备
  "common.grid": "Rangkaian elektrik",
  "common.evChargers": "Penjana cas untuk kenderaan elektrik (berbilang)",
  "common.evCharger": "Penjana cas untuk kenderaan elektrik",
  "common.pv": "Tenaga suria (PV)",
  "common.inverter": "Inverter (peranti menukar voltan)",
  "common.pcs": "Inverter + Bateri",
  "common.terminal": "Peranti terminal",
  "common.airc": "Penyejuk udara (AC)",
  "common.engine": "Enjin",
  "common.battery": "Bateri",
  "common.metter": "Meter elektrik",
  "common.other": "Lain-lain",
  "common.power": "Kuasa",
  "common.powerTotal": "Jumlah kuasa",
  "common.voltage": "Voltan",
  "common.electricity": "Tenaga elektrik",
  "common.current": "Arus elektrik",
  "common.homeUsage": "Jumlah beban rumah",
  "common.battery.power": "Kuasa bateri",

  // 数据
  "common.noDataAvailable": "Tiada data tersedia pada masa ini~",
  "common.tips": "Tip",
  "common.reset": "Tetapkan semula",
  "common.currencyUnit": "¥ (Yuan)",
  "common.submiting": "Mengemukakan... Sila tunggu...",
  "common.close": "Tutup",
  "common.from": "Dari",
  "common.useIn": "Untuk",
  "common.energyPercent": "Peratusan aliran tenaga",
  "common.dataFlow": "Aliran data",
  "common.getDataIng": "Mengambil data... Sila tunggu...",
  "common.pageLoading": "Memuat halaman... Sila tunggu...",
  "common.reseting": "Mengetapkan semula halaman... Sila tunggu...",
  "common.save": "Simpan",
  "common.onlyNumberTips": "Hanya nombor yang boleh dimasukkan",
  "common.offline": "Tidak dalam talian",
  "common.online": "Dalam talian",
  "common.fault": "Ralat (masalah)",
  "common.charge": "Cas (bateri)",
  "common.discharge": "Nyahcas (guna tenaga bateri)",
  "common.buy": "Beli",
  "common.sell": "Jual",
  "common.loadingInfo": "Memuat... Sila tunggu...",

  // 通用功能
  "common.moreFeatures": "Lebih banyak fungsi",
  "common.confirm": "Sahkan",
  "common.saveing": "Menyimpan... Sila tunggu...",
  "common.searchPlacholder": "Masukkan kata kunci untuk carian",
  "common.iSee": "Saya faham",
  "common.pageErrorTips1": "Oh, berlaku ralat pada halaman~",
  "common.pageErrorTips2": "Muatsurat semula halaman atau hubungi sokongan~",
  "common.refresh": "Segarkan",
  "common.backToHome": "Kembali ke halaman utama",
  "common.checkTips": "Memeriksa... Sila tunggu...",
  "common.back": "Kembali",
  "common.cancel": "Batal (hapus)",
  "common.optional": "Pilihan (tidak wajib)",
  "common.required": "Wajib diisi",
  "common.status": "Status",
  "common.statusNoDelete": "Tidak dihapus",
  "common.statusDelete": "Dihapus",
  "common.submit": "Hantar",
  "common.disable": "Nyahaktifkan",
  "common.enable": "Aktifkan",
  "common.year": "Tahun",
  "common.month": "Bulan",
  "common.day": "Hari",
  "common.version": "Versi:",
  "common.backHome": " Kembali ke halaman utama",
  "common.backHomeSorry": "Maaf, halaman telah hilang laluan secara tidak sengaja",
  "common.requestTips1": "Proses pengambilan data sedang berlangsung, jangan hantar semula",
  "common.requestTips2": "Notifikasi sistem",
  "common.requestTips3": "Sesi log masuk telah tamat, sila log masuk semula",
  "common.requestTips4": "Log masuk semula",
  "common.requestTips5": "Log masuk tidak sah atau sesi tamat, sila log masuk semula.",
  "common.requestTips6": "Ralat pelayan, sila cuba lagi kemudian.",
  "common.requestTips7": "Permintaan sistem telah tamat masa",
  "common.requestTips8": "Antaramuka sistem",
  "common.requestTips9": "Ralat",
  "common.iknow": "Saya faham",
  "common.logoutSuccess": "Log keluar berjaya",
  
  // 了解更多组件
  "common.knowMore.title": "Untuk maklumat lanjut, hubungi Beineng",
  "common.knowMore.email": "E-mel untuk hubungan",
  "common.knowMore.phone": "Nombor telefon untuk hubungan",
  "common.knowMore.wechat": "WeChat untuk hubungan",
  "common.knowMore.website": "Alamat laman web rasmi",
  "common.knowMore.address": "Alamat untuk hubungan",
  "common.knowMore.addressDetail": "Unit 1205, 1301, Bangunan 5, Jalan Qinghe 8, Kampung Huangjingkeng, Daerah Huangjiang, Bandar Dongguan, Negeri Guangdong",
  
  // 本地连接组件
  "common.localConnection": "Sambungan setempat",
  "common.operateInApp": "Lakukan operasi dalam aplikasi!",
  
  "common.enbleStaus": "Status aktif",
  "common.battery.status": "Tidak sedang cas, tidak sedang nyahcas",

  // 账户相关
  "account.forgetThePassword": "Lupa kata laluan",
  "account.logInDirectly": "Log masuk terus",
  "account.tips1": "Menukar halaman... Sila tunggu...",
  "account.tips2": "Pertama, baca dan terima terma penggunaan!",
  "account.autoLogin": "Log masuk automatik",
  "account.userLogin": "Log masuk pengguna",
  "account.registerTips": "Tiada akaun? Klik di sini untuk daftar",
  "account.userEmail": "Nama pengguna / E-mel",
  "account.userEmailTips": "Masukkan nama pengguna atau e-mel",
  "account.password": "Kata laluan",
  "account.passwordTips": "Masukkan kata laluan",
  "account.submit": "Hantar",
  "account.submitTips": "Mengemukakan... Sila tunggu...",
  "account.otherLoginTips": "Atau pilih kaedah log masuk lain",
  "account.userRegistration": "Pendaftaran pengguna",
  "account.userName": "Nama pengguna",
  "account.userNameTips": "Masukkan nama pengguna",
  "account.emailTips1": "Masukkan alamat e-mel",
  "account.emailTips2": "Format e-mel tidak sah",
  "account.phone": "Nombor telefon",
  "account.phoneTips1": "Masukkan nombor telefon",
  "account.phoneTips2": "Nombor telefon tidak sah",
  "account.phoneTips3": "Masukkan nombor telefon",
  "account.passwordTips1": "Masukkan kata laluan (6-30 aksara)",
  "account.passwordTips2": "Format kata laluan tidak sah: Kata laluan mestilah mengandungi huruf Inggeris, nombor, garis bawah (_), garis (-) dan titik (.), panjang 6-12 aksara",
  "account.passwordTips3": "Dua kata laluan yang dimasukkan tidak sama, sila semak dan masukkan semula!",
  "account.passwordTips4": "Masukkan kata laluan: Kata laluan mestilah mengandungi huruf Inggeris, nombor, garis bawah (_), garis (-) dan titik (.)",
  "account.passwordTips5": "Sahkan kata laluan",
  "account.passwordTips6": "Masukkan untuk mengesahkan kata laluan",
  "account.passwordTips7": "Dua kata laluan yang dimasukkan tidak sama, sila semak dan masukkan semula!",
  "account.passwordTips8": "Masukkan untuk mengesahkan kata laluan",
  "account.passwordTips9": "Tahniah, pendaftaran berjaya!",
  "account.passwordTips10": "Nama pengguna anda ialah:",
  "account.emailIs": "E-mel anda ialah:",
  "account.goToLoginPage": "Akan dialihkan ke halaman log masuk secara automatik dalam s saat",
  "account.goLogin": "Log masuk",
  "account.goRegister": "Daftar",
  "account.loginSuccess": "Log masuk berjaya",
  "account.email": "E-mel",
  "account.sologn": "Kami mencipta platform tenaga bersepadu yang direka khas untuk anda",
  "account.pleaseAgree": "Saya telah membaca dan bersetuju dengan",
  "userAgreement.privacyPolicy": "Dasar privasi",

  // 验证码相关
  "account.code": "Kod pengesahan",
  "account.codeTips": "Masukkan kod pengesahan",
  "account.codeTips2": "Kod pengesahan tidak sah",

    "account.inviteCodeTips": "Sila masukkan kod jemputan",
    "account.inviteCodeHint": "Sila hubungi pemasang atau kakitangan operasi dan penyelenggaraan untuk mendapatkan kod jemputan",
  // 密码修改与恢复
  "account.modifyPasswordByAccount": "Ubah kata laluan melalui akaun",
  "account.modifyPasswordByEmail": "Ubah kata laluan melalui e-mel",
  "account.getPasswordByAccount": "Dapatkan kata laluan melalui akaun",
  "account.getPasswordByEmail": "Dapatkan kata laluan melalui e-mel",

  "account.sendEmailTips": "Kod pengesahan telah dihantar ke e-mel, sila semak",
  "account.name": "Nama akaun",
  "account.newPassword": "Kata laluan baru",
  "account.confirmNewPassword": "Sahkan kata laluan baru",
  "account.nameTips": "Masukkan nama akaun",
  "account.passwordModifySuccess": "Ubah kata laluan berjaya",
  "account.emailCode": "Kod pengesahan e-mel",
  "account.emailCodeTips": "Masukkan kod pengesahan e-mel",
  "account.emailCodeTips2": "Kod pengesahan e-mel tidak sah",
  "account.emailModifySuccess": "Ubah kata laluan berjaya",
  "account.passworTips1": "Kata laluan anda telah ditetapkan semula!",
  "account.passwordTips11": "Masukkan untuk mengesahkan kata laluan",
  "account.passwordTips12": "Masukkan kata laluan baru",
  "account.nickname": "Nama panggilan",
  "account.modifyNickname": "Ubah nama panggilan",
  "account.modifyNicknameSuccess": "Ubah nama panggilan berjaya!",
  "account.nicknameTips": "Masukkan nama panggilan",
  "account.nicknameError": "Ubah nama panggilan gagal!",

  // 快速注册与登录
  "account.login": "Log masuk",
  "account.quickRegister": "Pendaftaran cepat",
  "account.sendCode": "Hantar kod",
  "account.sendTips": "Boleh hantar semula dalam s saat",
  "account.sendEmailIng": "Mengirim e-mel... Sila tunggu...",
  "account.emailNotEmpty": "Ruangan e-mel tidak boleh kosong",
  "account.registerAccount": "Pendaftaran akaun",
  "account.registerWelcome": "Selamat datang ke pendaftaran SusprSafe",
  "account.usernameLimit": "Nama pengguna mestilah bermula dengan huruf, hanya boleh mengandungi huruf, nombor dan garis bawah (_), panjang 5-15 aksara",

  // 版权信息
  "copyright.desc2": "Maklumat pendaftaran laman web: Nombor pendaftaran ICP Negeri Guangdong 2021169764",

  // 用户信息编辑
  "editUserInfo.editUserInformation": "Edit maklumat pengguna",
  "editUserInfo.modifyUsername": "Ubah nama pengguna",
  "editUserInfo.changePictures": "Tukar gambar profil",
  "editUserInfo.savePicturesSuccess": "Simpan gambar profil berjaya",
  "editUserInfo.saveError": "Simpan gagal",
  "editUserInfo.pictureLimit": "Saiz gambar tidak boleh melebihi 2 MB",
  "editUserInfo.uploadPicture": "Muat naik gambar profil",
  "editUserInfo.picturePreview": "Pratonton",
  
  "editUserInfo.bindPhoneNumber": "Hubungkan nombor telefon",
  "editUserInfo.bindEmail": "Hubungkan e-mel",
  "editUserInfo.changePassword": "Ubah kata laluan",

  "editUserInfo.notificationSettings": "Tetapan notifikasi",
  "editUserInfo.editAccount": "Edit maklumat akaun",
  "editUserInfo.waitBingting": "Mengaitkan... Sila tunggu...",
  "editUserInfo.collapse": "Ciutkan (pisahkan)",
  "editUserInfo.modifyBinding": "Ubah pengikatan",
  
  "editUserInfo.emailAddress": "Alamat e-mel",
  "editUserInfo.tips1": "Pengikatan e-mel berjaya",
  "editUserInfo.tips2": "Simpan gagal",
  "editUserInfo.tips3": "Mengirim kod pengesahan e-mel... Sila tunggu...",
  "editUserInfo.tips4": "Kod pengesahan telah dihantar ke e-mel xxxx, sila semak",
  "editUserInfo.tips5": "Hantar kod pengesahan gagal!",
  "editUserInfo.tips6": "Nombor telefon telah dihubungkan",
  "editUserInfo.tips7": "E-mel telah dihubungkan",
  "editUserInfo.emailTips1": "Masukkan alamat e-mel",
  "editUserInfo.emailTips2": "Format e-mel tidak sah",
  "editUserInfo.emailTips3": "Boleh hantar semula dalam xxxx saat",
  "editUserInfo.emailTips4": "Hantar kod",
  "editUserInfo.emailTips5": "Ruangan kod pengesahan e-mel tidak boleh kosong",
  "editUserInfo.emailTips6": "Kod pengesahan e-mel tidak sah",
  "editUserInfo.emailCode": "Kod pengesahan e-mel",
  "editUserInfo.save": "Simpan",

  // 手机绑定相关
  "editUserInfo.phoneTips1": "Pengikatan nombor telefon berjaya",
  "editUserInfo.phoneTips2": "Mengirim kod pengesahan SMS... Sila tunggu...",
  "editUserInfo.phoneTips3": "Kod pengesahan SMS telah dihantar ke nombor xxxx, sila semak",
  "editUserInfo.phoneTips4": "Hantar kod pengesahan SMS gagal!",
  "editUserInfo.phoneTips5": "Masukkan nombor telefon",
  "editUserInfo.phoneTips6": "Format nombor telefon tidak sah",
  "editUserInfo.phoneTips7": "Hantar kod pengesahan SMS",
  "editUserInfo.phoneTips8": "Kod pengesahan SMS",
  "editUserInfo.phoneTips9": "Ruangan kod pengesahan SMS tidak boleh kosong",
  "editUserInfo.phoneTips10": "Kod pengesahan SMS tidak sah",
  "editUserInfo.phone": "Nombor telefon",


  // 通知设置
  "editUserInfo.noticeTips1": "Gagal mengambil tetapan notifikasi!",
  "editUserInfo.noticeTips2": "Simpan tetapan notifikasi berjaya!",
  "editUserInfo.noticeTips3": "Notifikasi tahap bateri rendah",
  "editUserInfo.noticeTips4": "Notifikasi pengecasan selesai",
  "editUserInfo.errorNotification": "Notifikasi ralat",
  "editUserInfo.updateNotification": "Notifikasi kemas kini",
  "editUserInfo.monthlyStatisticsNotification": "Notifikasi statistik bulanan",
  "editUserInfo.notificationMethod": "Kaedah penerimaan",

  // 用户名相关提示
  "editUserInfo.userNameTips1": "Simpan nama pengguna berjaya",
  "editUserInfo.userNameTips2": "Simpan nama pengguna gagal",
  "editUserInfo.userNameTips3": "Masukkan nama pengguna",
  "editUserInfo.userNameTips4": "Format nama pengguna tidak sah: Hanya boleh mengandungi nombor, garis bawah (_) dan huruf Inggeris",
  "editUserInfo.userNameTips5": "Masukkan nama pengguna",
  "editUserInfo.userNameTips6": "Menyimpan... Sila tunggu...",
  "editUserInfo.userName": "Nama pengguna",

  // 头像编辑提示
  "editUserInfo.avatorTips": "Klik untuk menukar gambar profil",
  "editUserInfo.verifyCodeTips1": "Masukkan kod pengesahan yang diterima:",
  "editUserInfo.verifyCodeTips2": "Untuk keselamatan akaun anda, klik butang di bawah untuk menghantar kod pengesahan ke nombor telefon asal:",
  "editUserInfo.verifyCodeTips3": "Hantar kod",
  "editUserInfo.verifyCodeTips4": "Pengesahan nombor telefon asal berjaya, masukkan nombor telefon baru yang akan dihubungkan",
  "editUserInfo.verifyCodeTips5": "Untuk keselamatan akaun anda, klik butang di bawah untuk menghantar kod pengesahan ke e-mel asal:",
  "editUserInfo.verifyCodeTips6": "Pengesahan e-mel asal berjaya, masukkan e-mel baru",
  "editUserInfo.verifyCodeTips7": "Kata laluan lama",
  "editUserInfo.verifyCodeTips8": "Pertama, hubungkan e-mel!",
  "editUserInfo.verifyCodeTips9": "Kod pengesahan telah dihantar ke e-mel, sila semak",
  "editUserInfo.verifyCodeTips10": ", akan dialihkan ke halaman log masuk secara automatik",

  // 通知相关
  "hems.notice.title": "Tajuk notifikasi", 
  "hems.notice.content": "Isi notifikasi", 
  "hems.notice.operate": "Operasi",
  "hems.notice.noRead": "Belum dibaca",
  "hems.notice.read": "Telah dibaca",
  "hems.notice.warning": "Amaran",
  "hems.notice.error": "Ralat",
  "hems.notice.success": "Pengiraan statistik",
  "hems.notice.sys": "Maklumat sistem",
  "hems.notice.operateSuccess": "Operasi berjaya",
  "hems.notice.operateTips": "Pilih item untuk dioperasikan",

  // 首页
  "hems.home.selfuseRate": "Peratusan penggunaan sendiri",
  "hems.home.percent": "Peratusan",
  "hems.home.todayData": "Data hari ini",
  "hems.home.todayPowerGeneration": "Tenaga dijana hari ini",
  "hems.home.salesIncome": "Pendapatan jualan tenaga",
  "hems.home.saved": "Anda telah menjimatkan",
  "hems.home.reduce": "Kurangkan jejak karbon",
  "hems.home.tips1": "Tiada data tersedia pada masa ini, anda belum menghubungkan xxxx",
  "hems.home.criticalLoad": "Beban kritikal",
  "hems.home.keyVoltage": "Voltan kritikal",
  "hems.home.householdLoad": "Beban rumah",
  "hems.home.householdVoltage": "Voltan rumah",
  "hems.home.generalLoad": "Beban am",
  "hems.home.generalVoltage": "Voltan am",
  "hems.home.batteryHealth": "Status kesihatan bateri",
  "hems.home.averageTemp": "Suhu purata",
  "hems.home.gridLoad": "Beban rangkaian elektrik",
  "hems.home.toggeleDataSource": "Data yang dipaparkan telah diubah seperti berikut:",
  "hems.home.toggleTips": "Adakah anda mahu mengubah?",
  "hems.home.modeSending": "Mengirim arahan mod... Sila tunggu...",
  "hems.home.modeSuccess": "Ubah mod berjaya dihantar!",
  "hems.home.isOnline": "Adakah dalam talian?",
  "hems.home.useStatus": "Status penggunaan",
  "hems.home.workModeText": "Mod kerja semasa:",
  "hems.home.toggleDataSourceText": "Data yang dipaparkan telah diubah seperti berikut:",
  "hems.ev.charge.status": "Status pengecasan",
  "hems.ev.charge.time": "Masa pengecasan",
  "hems.ev.charge.count": "Jumlah pengecasan sebenar (seiring masa)",
  "hems.ev.charge.status.empty": "Kosong",
  "hems.ev.charge.status.ing": "Dihubungkan ke bateri. Sedang mengecas",
  "hems.ev.charge.status.null": "Dihubungkan ke bateri, tetapi tidak sedang mengecas",
  "hems.ev.charge.status.error": "Ralat",
  "hems.hour": "Jam",
  "hems.minue": "Minit",
  "hems.ev.chagre.number": "Nombor penjana cas",

  // 用户指南
  "hems.userGuide.selfUse": "Gunakan tenaga dijana sendiri",
  "hems.userGuide.selfUseTips": "Pertama, gunakan tenaga suria, jika tidak mencukupi, isi dengan rangkaian elektrik",
  "hems.userGuide.economyMode": "Mod ekonomi",
  "hems.userGuide.economyModeTips": "Optimumkan strategi penggunaan tenaga berdasarkan kadar tenaga elektrik",
  "hems.userGuide.emergencyMode": "Mod kecemasan",
  "hems.userGuide.emergencyModeTips": "Utamakan bekalan tenaga untuk beban kritikal",

  // 图表页面
  "hems.history.energyStatistics": "Statistik tenaga",
  "hems.history.revenueStatistics": "Statistik pendapatan",
  "hems.history.greenStatistics": "Pengurangan pelepasan hijau",
  "hems.history.revenueTitle": "Jumlah pendapatan jualan tenaga",
  "hems.history.savingsTitle": "Jumlah penjimatan",
  "hems.history.carbonTitle": "Jumlah pengurangan karbon",
  "hems.history.day": "Hari",
  "hems.history.month": "Bulan",
  "hems.history.year": "Tahun",
  "hems.history.beforeDay": "Kemarin",
  "hems.history.afterDay": "Esok",
  "hems.history.beforeMonth": "Bulan lepas",
  "hems.history.afterMonth": "Bulan hadapan",
  "hems.history.beforeYear": "Tahun lepas",
  "hems.history.afterYear": "Tahun hadapan",
  "hems.history.totalUse": "Jumlah penggunaan",
  "hems.history.fullScreen": "Skrin penuh",
  "hems.history.timeSelect": "Pilih hari",
  "sync.tips1": "Arahan penyegerakan data berjaya dihantar!",
  "sync.tips2": "Melakukan penyegerakan data, memerlukan masa kerana jumlah data besar, semak semula dalam 50 minit~",
  "sync.tips3": "Penyegerakan data peranti mungkin tertinggal, jika anda melihat ketidaksesuaian dalam data, klik butang di bawah:",
  "sync.tips4": "Segerakkan data",

  // 充电桩信息
  "charge.info": "Maklumat penjana cas",
  "news.loading": "Memuat...",
  "news.noMore": "Tiada data lagi",
  "hems.pv.power": "Jumlah tenaga suria",

  // UEH特定功能
  "ueh.sellPower": "Jumlah tenaga yang dijual",
  
  // 菜单
  "menu.home": "Halaman Utama",
  "menu.history": "Data Sejarah",
  "menu.device": "Peranti",
  "menu.settings": "Tetapan",
  "menu.messageCenter": "Pusat Mesej",
  "menu.help": "Bantuan dan Sokongan",
  "menu.mine": "Saya (peribadi)",


  // 我的设置
  "mine.userSetting": "Tetapan Pengguna",
  "mine.terminalSetting": "Tetapan asas terminal",
  "mine.uploadCloud": "Muat naik data ke awan",
  "mine.changeVersion": "Semak kemas kini",
  "mine.language": "Tukar bahasa",
  "mine.about": "Tentang aplikasi",
  "mine.feedback": "Maklum balas",
  "mine.logout": "Log keluar",
  "mine.logoutAccount": "Padam akaun",

  // 注销账户相关
  "mine.logoutAccountTips": "Padam akaun bernama []",
  "mine.logoutAccountTips1": "Padam akaun yang dihubungkan dengan []",
  "mine.logoutAccountCare": "Nota permintaan pemadaman akaun:",
  "mine.logoutAccountCare1": "1. Akaun dalam keadaan selamat",
  "mine.logoutAccountCare1-1": "Akaun dalam mod penggunaan biasa, tiada risiko pencurian, pelanggaran peraturan atau penutupan",
  "mine.logoutAccountCare2": "2. Akses dan pengikatan akaun dihapus",
  "mine.logoutAccountCare2-1": "Semua akses akaun untuk platform pihak ketiga dihapus",
  "mine.logoutAccountCare3": "3. Selepas dipadam, akaun tidak boleh dipulihkan, data pengguna dihapus",
  "mine.logoutAccountCare3-1": "Selepas dipadam, nombor telefon, e-mel dan data berkaitan yang dihubungkan dihapus, tidak boleh dipulihkan",
  "mine.confirmLogout": "Sahkan pemadaman",
  "mine.logoutSuccess": "Akaun berjaya dipadam!",


  // 反馈问题
  "mine.feedbackIssues": "Masalah dan Maklum balas",
  "mine.feedQuantity": "Kuantiti",
  "mine.feedAmount": "Maksimum 9 gambar, saiz maksimum setiap gambar 1 MB",

  // 通知设置相关
  "mine.notice.fail": "Gagal mengambil tetapan notifikasi!",
  "mine.notice.saveSuccess": "Simpan tetapan notifikasi berjaya!",
  "mine.notice.saveFail": "Simpan gagal!",
  "mine.notice.title": "Tetapan notifikasi",
  "mine.notice.batteryLow": "Notifikasi tahap bateri rendah",
  "mine.notice.chargingFinish": "Notifikasi pengecasan selesai",
  "mine.notice.error": "Notifikasi ralat",
  "mine.notice.update": "Notifikasi kemas kini",
  "mine.notice.monthly": "Notifikasi statistik bulanan",
  "mine.notice.receiveType": "Kaedah penerimaan",

  // 语言设置欢迎语
  "mine.language.welcome": "Selamat datang ke SusprSafe",
  "mine.language.desc1": "Pilih versi bahasa mengikut tempat tinggal anda",
  "mine.language.desc2": "Anda boleh menukarnya bila-bila masa dalam tetapan aplikasi",

  // 个人信息
  "mine.userInfo.avatar": "Gambar Profil",
  "mine.userInfo.nickname": "Nama Panggilan",
  "mine.userInfo.password": "Kata Laluan",
  "mine.userInfo.changePassword": "Ubah Kata Laluan",
  "mine.userInfo.setPassword": "Tetapkan Kata Laluan",
  "mine.userInfo.phoneNumber": "Nombor Telefon",
  "mine.userInfo.bindPhone": "Hubungkan Telefon",
  "mine.userInfo.bindEmail": "Hubungkan E-mel",
  "mine.loginExpired": "Sesi log masuk telah tamat, sila log masuk semula",
  "mine.userInfo.title": "Maklumat Pengguna",
  "mine.userInfo.bind": "Hubungkan",
  "mine.userInfo.modify": "Ubah",
  "mine.userInfo.modifyNickname": "Ubah Nama Panggilan",
  "mine.userInfo.userNickname": "Nama Panggilan Pengguna",
  "mine.userInfo.selectPic": "Pilih gambar untuk dimuat naik",
  "mine.userInfo.saveSuccess": "Simpan berjaya",
  "mine.userInfo.uploadFail": "Muat naik gagal",
  "mine.userInfo.avatarSaveSuccess": "Simpan gambar profil berjaya",
  "mine.userInfo.nameTips1": "Ruangan nama panggilan tidak boleh kosong",
  "mine.userInfo.nameTips2": "Masukkan nama panggilan",

  // 通用选择提示
  "common.pleaseSelect": "Sila pilih",
  "question.commonQuestions": "Soalan Lazim",
  "account.toggleLanguage": "Tukar Bahasa",
  "account.localConnection": "Sambungan Setempat",
  "account.selectLanguage": "Sila pilih bahasa",
  "account.sendEmailToast": "Kod pengesahan telah dihantar ke e-mel xxx, sila semak",
  "account.emailError": "Format e-mel tidak sah",
  "account.sendEmailFail": "Hantar gagal, sila cuba lagi",
  
  "common.submitting": "Mengemukakan... Sila tunggu...",

  "device.page.noData": "Tiada data tersedia pada masa ini, halaman ini hanya boleh dilihat dalam aplikasi"
,

  // OTA Upgrade
  "bmsFirmware.upgrade": "Upgrade",
  "bmsFirmware.upgrading": "Upgrading...",
  "bmsFirmware.uploadingFile": "Uploading firmware file...",
  "bmsFirmware.upgradingProgress": "Upgrading firmware... {progress}%",
  "bmsFirmware.upgradeSuccess": "Upgrade Successful",
  "bmsFirmware.upgradeSuccessSubtitle": "BMS firmware upgrade completed!",
  "bmsFirmware.upgradeFailed": "Upgrade Failed",
  "bmsFirmware.upgradeFailedFormError": "Please check if the form is filled correctly",
  "bmsFirmware.upgradeFailedNetworkError": "Network error, please retry",
  "bmsFirmware.invalidFileType": "Please select a valid firmware file (.bin, .hex, .fw, .firmware)",
  "bmsFirmware.selectFileWarning": "Please select a firmware file first",
  "bmsFirmware.statusUpgrading": "Upgrading",
  "bmsFirmware.statusCompleted": "Upgrade Completed",
  "bmsFirmware.statusFailed": "Upgrade Failed",
  "bmsFirmware.deviceUpgrading": "Upgrading firmware package, upgrade takes 30 ~ 50 minutes, real-time device data cannot be viewed during this period, please wait...",
  "bmsFirmware.upgradeStatusLabel": "Upgrade Status",
  "bmsFirmware.upgradeProgressLabel": "Upgrade Progress",
  "bmsFirmware.currentPackageLabel": "Current transmitted data package number",
  "bmsFirmware.totalPackagesLabel": "Total data packages",
  "bmsFirmware.upgradeFailedCheckDevice": "Please check device status and retry upgrade",

  // Setting Result Dialog Translations
  "settingResult.defaultTitle": "Setting Successful",
  "settingResult.defaultSubTitle": "Parameter settings saved",
  "settingResult.confirmButton": "OK"
};